/**
 * Sokora Celebratory Confetti Engine
 * Tailored for Sokora brand colors & milestones (₹1499 2 Free Gifts unlock).
 * Pure HTML5 Canvas, 60fps, zero external dependencies, auto-cleanup.
 */
(function() {
  'use strict';

  var SOKORA_COLORS = [
    '#C44D68', // Brand Deep Rose Pink
    '#FF4D79', // Vibrant Hot Pink
    '#FF6B8B', // Soft Blossom Coral
    '#FFD700', // Sparkling Gold (Golden Glaze theme)
    '#FFA500', // Amber Gold
    '#FAD3DC', // Pastel Soft Pink
    '#FFFFFF'  // Gleaming White
  ];

  function drawStar(ctx, cx, cy, spikes, outerRadius, innerRadius) {
    var rot = Math.PI / 2 * 3;
    var x = cx;
    var y = cy;
    var step = Math.PI / spikes;

    ctx.beginPath();
    ctx.moveTo(cx, cy - outerRadius);
    for (var i = 0; i < spikes; i++) {
      x = cx + Math.cos(rot) * outerRadius;
      y = cy + Math.sin(rot) * outerRadius;
      ctx.lineTo(x, y);
      rot += step;

      x = cx + Math.cos(rot) * innerRadius;
      y = cy + Math.sin(rot) * innerRadius;
      ctx.lineTo(x, y);
      rot += step;
    }
    ctx.lineTo(cx, cy - outerRadius);
    ctx.closePath();
    ctx.fill();
  }

  function ConfettiParticle(x, y, angle, speed, shape, color) {
    this.x = x;
    this.y = y;
    this.vx = Math.cos(angle) * speed;
    this.vy = -Math.sin(angle) * speed;
    this.shape = shape; // 'rect', 'circle', 'star'
    this.color = color;
    this.size = (shape === 'star' ? 6 : (shape === 'circle' ? 4 : 7)) + Math.random() * 4;
    this.gravity = 0.38 + Math.random() * 0.15;
    this.drag = 0.96;
    this.tiltAngle = Math.random() * Math.PI * 2;
    this.tiltSpeed = 0.08 + Math.random() * 0.12;
    this.opacity = 1;
    this.fade = 0.008 + Math.random() * 0.006;
    this.wobble = Math.random() * Math.PI * 2;
    this.wobbleSpeed = 0.05 + Math.random() * 0.05;
  }

  ConfettiParticle.prototype.update = function() {
    this.vx *= this.drag;
    this.vy *= this.drag;
    this.vy += this.gravity;
    this.x += this.vx;
    this.y += this.vy;
    this.tiltAngle += this.tiltSpeed;
    this.wobble += this.wobbleSpeed;
    this.opacity -= this.fade;
    return this.opacity > 0 && this.y < (window.innerHeight + 50);
  };

  ConfettiParticle.prototype.draw = function(ctx) {
    if (this.opacity <= 0) return;
    ctx.save();
    ctx.fillStyle = this.color;
    ctx.globalAlpha = Math.max(0, Math.min(1, this.opacity));
    ctx.translate(this.x + Math.sin(this.wobble) * 2, this.y);

    var tiltCos = Math.cos(this.tiltAngle);
    ctx.scale(tiltCos, 1);

    if (this.shape === 'circle') {
      ctx.beginPath();
      ctx.arc(0, 0, this.size / 2, 0, Math.PI * 2);
      ctx.fill();
    } else if (this.shape === 'star') {
      drawStar(ctx, 0, 0, 5, this.size, this.size / 2.2);
    } else {
      ctx.fillRect(-this.size / 2, -this.size / 3, this.size, this.size * 1.5);
    }

    ctx.restore();
  };

  window.triggerSokoraConfetti = function(options) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var opts = options || {};
    var duration = opts.duration || 3200;

    var canvas = document.getElementById('sokora-confetti-canvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'sokora-confetti-canvas';
      canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:99999999;';
      document.body.appendChild(canvas);
    }

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;

    function resizeCanvas() {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.scale(dpr, dpr);
    }
    resizeCanvas();

    var particles = [];
    var shapes = ['rect', 'rect', 'circle', 'star'];

    function spawnCannon(x, y, minAngle, maxAngle, count, speedRange) {
      for (var i = 0; i < count; i++) {
        var angle = minAngle + Math.random() * (maxAngle - minAngle);
        var speed = speedRange[0] + Math.random() * (speedRange[1] - speedRange[0]);
        var shape = shapes[Math.floor(Math.random() * shapes.length)];
        var color = SOKORA_COLORS[Math.floor(Math.random() * SOKORA_COLORS.length)];
        particles.push(new ConfettiParticle(x, y, angle, speed, shape, color));
      }
    }

    var w = window.innerWidth;
    var h = window.innerHeight;

    // Wave 1: Twin cannons shooting upwards from bottom corners
    spawnCannon(w * 0.15, h * 0.95, Math.PI * 0.22, Math.PI * 0.45, 65, [14, 26]);
    spawnCannon(w * 0.85, h * 0.95, Math.PI * 0.55, Math.PI * 0.78, 65, [14, 26]);

    // Wave 2: Center ceiling shower after 250ms
    setTimeout(function() {
      spawnCannon(w * 0.5, h * 0.35, Math.PI * 0.1, Math.PI * 0.9, 70, [8, 18]);
      spawnCannon(w * 0.85, h * 0.45, Math.PI * 0.3, Math.PI * 0.7, 50, [10, 22]); // Right side near cart drawer
    }, 260);

    var animId;
    var startTime = Date.now();

    function render() {
      ctx.clearRect(0, 0, w, h);

      for (var i = particles.length - 1; i >= 0; i--) {
        var alive = particles[i].update();
        if (alive) {
          particles[i].draw(ctx);
        } else {
          particles.splice(i, 1);
        }
      }

      if (particles.length > 0 && (Date.now() - startTime) < duration) {
        animId = requestAnimationFrame(render);
      } else {
        cancelAnimationFrame(animId);
        if (canvas && canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
      }
    }

    animId = requestAnimationFrame(render);
  };
})();
